import PreferenceSchema from '@/preferenceSchema';

import LocalStoragePreferencesProvider from '@/providers/preferences/localStorage.provider';

const PROVIDER_MAP = {
  LOCAL_STORAGE: LocalStoragePreferencesProvider,
};

const state = Object.fromEntries(Object.keys(PreferenceSchema).map(key => [key, null]));

const actions = {
  async load({ commit, rootState }) {
    const preferenceMap = await PROVIDER_MAP[rootState.preferenceProvider].getMap();

    for (const preference in PreferenceSchema) {
      if (PreferenceSchema.hasOwnProperty(preference)) {
        let value;
        if (preferenceMap.hasOwnProperty(preference)) {
          value = preferenceMap[preference];
        } else {
          value = PreferenceSchema[preference].default;
        }
        commit('set', { key: preference, value });
      }
    }
  },

  async set({ commit, rootState }, { key, value }) {
    const preference = PreferenceSchema[key];

    if (preference === undefined) {
      throw Error(`${key} is not a valid preference`);
    }

    // Validate preference value
    switch (preference.type) {
      case 'enum':
        if (!preference.values.includes(value)) {
          throw Error(`${value} is not a valid value for preference ${key}`);
        }
        break;
      default:
        throw Error(`Preference type ${preference.type} not implemented!`);
    }

    await PROVIDER_MAP[rootState.preferenceProvider].setKey(key, value);
    commit('set', { key, value });
  },
};

const mutations = {
  set(state, { key, value }) {
    state[key] = value;
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
};
